// Timezone utility for consistent GMT+8 (Singapore) display across the system
// All timestamps are converted to Singapore Time (UTC+8)

export const formatToGMT8 = (date, includeTime = true) => {
  if (!date) return '';

  // Several DB timestamp columns (e.g. app_wellis.email_logs.attempted_at)
  // are naive TIMESTAMP (no tz marker) storing Postgres's NOW(), which is
  // UTC on this server -- PostgREST returns those without a "Z" suffix, so
  // new Date(date) would otherwise parse a string as browser-local time
  // instead of UTC, silently shifting it before the Asia/Singapore
  // conversion below is even applied. Force UTC parsing for any string
  // missing an explicit timezone marker; Date objects and properly
  // tz-marked strings pass through unchanged.
  let normalized = date;
  if (typeof date === 'string' && !/[Zz]|[+-]\d{2}:?\d{2}$/.test(date)) {
    normalized = `${date}Z`;
  }
  const d = new Date(normalized);

  // Format: DD/MM/YYYY HH:MM:SS (GMT+8)
  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Singapore',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...(includeTime && {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
  });

  const parts = formatter.formatToParts(d);
  const partMap = {};

  parts.forEach(({ type, value }) => {
    partMap[type] = value;
  });

  if (includeTime) {
    return `${partMap.day}/${partMap.month}/${partMap.year} ${partMap.hour}:${partMap.minute}:${partMap.second}`;
  } else {
    return `${partMap.day}/${partMap.month}/${partMap.year}`;
  }
};

export const formatDateOnly = (date) => formatToGMT8(date, false);

export const formatDateTime = (date) => formatToGMT8(date, true);
